import styled from "styled-components";
import { LOTTIE_CONTAINER } from "@dineout-cart-ui/constants/index";
import { getCloudinaryUrl } from "@swiggy-private/core-ui";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";


export const RewardWidgetBackgroundImage = styled.div<{ backgroundImage?: string; booster?: boolean }>(({ backgroundImage, theme, booster }) => ({
    ...(backgroundImage ? { backgroundImage: `url(${getCloudinaryUrl(backgroundImage)})` } : {}),
         backgroundSize: "cover",
         backgroundPosition: "center",
         backgroundRepeat: "no-repeat",
         margin : `${theme.spacing.large} ${theme.spacing.small}`,
         borderRadius: theme.cornerRadius.medium,
         padding: booster ? `${theme.spacing.xxSmall}` : undefined,
}));

export const BoosterComponent = styled.div(({theme})=>({
    display: "flex"  ,
    padding: theme.spacing.xSmall,
    position: "relative",
}));

export const LogoContainer = styled.div(()=>({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));

export const TextContainer = styled.div(({theme})=>({
    display: "flex",
    flexDirection: "column",
    marginLeft: theme.spacing.xSmall,
}));

export const CalloutIcon = styled.div(({theme})=>({
    position: "absolute",
    top: theme.spacing.xSmall,
    right: theme.spacing.xSmall,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));

export const LottieContainer = styled.div<{useRewardTitle?: string; isAnimationComplete?: boolean}>(({theme, useRewardTitle, isAnimationComplete})=>({
    position: "absolute",
    top: LOTTIE_CONTAINER.TOP_POSITION,
    right: theme.spacing.small,
    width: useRewardTitle ? LOTTIE_CONTAINER.WIDTH_WITH_TITLE : LOTTIE_CONTAINER.WIDTH_WITHOUT_TITLE,
    height: useRewardTitle ? LOTTIE_CONTAINER.HEIGHT_WITH_TITLE : LOTTIE_CONTAINER.HEIGHT_WITHOUT_TITLE,
    display: isAnimationComplete ? "none" : "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1,
    overflow: "hidden",
}));

export const TitleText = styled(Text)(()=>({
    opacity: 0.5,
}));
